const initialTableStore = {
  searchText: '', page: 1, perPage: 10, search: null,
};

export default initialTableStore;
